export default function Subtitle({ title }) {
  return (
    <div className="flex items-center pt-4 mt-10 mb-7">
      <div
        style={{ minWidth: "110em" }}
        className="absolute left-0 w-full h-10 bg-gradient-to-r from-transparent bg-neutral-100 z-10"
      />
      <label className="text-xl z-20 font-semibold">{title}</label>
    </div>
  );
}
